module.exports = __webpack_public_path__ + "static/media/success.16c9b904.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/instanceScreenshotViewer/instances/instanceControlPanel/maintenanceMonitor/maintenanceCommand/symbols/success.svg
// module id = 907
// module chunks = 0